import admin from '@Apis/admin.api';
import { deviceApi as edgeManager } from '@Apis/device.api';
import { DeploymentOptions } from '@Types/implementation';

export const getConfigV2ZipService = () =>
	admin.get('/greengrass/v2-configurations', {
		responseType: 'blob',
		headers: {
			Accept: 'application/zip',
		},
	});

// TODO: deprecate this
export const deployGreengrassV2Service = (
	deployOption = DeploymentOptions.LATEST,
) => admin.post('/greengrass/v2-deploy', { deployOption });

type GetMsiRequest = { global?: boolean };
export const getMsiInstallerUrlService = (req?: GetMsiRequest) => {
	const { global = false } = req ?? {};
	return edgeManager.get('/installer/msi/url', { params: { global } });
};

export const createMsiInstallerService = () =>
	edgeManager.post('/installer/msi/create', {});

export const statusMsiInstallerService = () =>
	edgeManager.get('/installer/msi/status');

type GetMsiCodeRequest = {
	poll?: boolean;
	useDefaultPorts?: boolean;
};
export const getConfigCodeService = (req?: GetMsiCodeRequest) => {
	const { poll = true, useDefaultPorts = false } = req ?? {};
	return edgeManager.get('/installer/configuration', {
		params: { poll, useDefaultPorts },
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

export const createConfigCodeDynamicService = (
	params: { useDefaultPorts?: boolean } = {},
) => {
	return edgeManager.post('/installer/configuration/create', null, {
		params,
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

export const getDataConnectorStatusByDevice = (deviceId: string) =>
	edgeManager.get(`/certificate/${deviceId}/status`);

export const setDataConnectorStatusByDevice = (
	deviceId: string,
	desiredStatus: 'Enabled' | 'Disabled',
) => edgeManager.put(`/certificate/${deviceId}/status`, { desiredStatus });

export const deployDevice = () => edgeManager.post('/deploy', {});

export const deployDeviceV2 = (deployOption = DeploymentOptions.LATEST) =>
	edgeManager.post('/deploy-v2', { deployOption });
